import FlexPane from './_flex-pane.js'
import ExpandableView from './_expandable-view.js'
import CountryIcon from './_country-icon.js'
import Text from './_text.js'
import ButtonBar from './_button-bar.js'
import RaceExplanationPane from './_race-explanation-pane.js'
import RaceMeetingCoupon from './_race-meeting-coupon.js'

export default {
  name: 'CollapsibleMeetingPane',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          padding: '0 8px',
        },
      },
    },
    expandableView: {
      configSet: ExpandableView,
      configValues: {
        initiallyExpanded: true,
        headerContainer: {
          style: {
            base: {
              padding: 0,
              minHeight: '40px',
            },
          },
        },
      },
    },
    shouldShowFlag: true,
    contentContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    meetingsContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    meetingContentContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
        separator: {
          style: {
            size: '1px',
            margin: '2px 0',
          },
        },
      },
    },
    countryIcon: {
      configSet: CountryIcon,
      configValues: {},
    },
    title: {
      configSet: Text,
      configValues: {
        truncate: true,
        container: {
          flexGrow: 1,
        },
      },
    },
    locationsButtonBar: {
      configSet: ButtonBar,
      configValues: {
        container: {
          style: {
            padding: '8px 0px 0px 0px',
            minHeight: '40px',
          },
        },
        button: {
          selected: {
            style: {
              base: {
                minHeight: '32px',
                minWidth: '64px',
                whiteSpace: 'noWrap',
              },
            },
          },
          unselected: {
            style: {
              base: {
                minHeight: '32px',
                minWidth: '64px',
                whiteSpace: 'noWrap',
                borderWidth: '1px',
                borderStyle: 'solid',
              },
            },
          },
        },
      },
    },
    raceExplanationPane: {
      configSet: RaceExplanationPane,
      configValues: {
        explanationItemsContainer: {
          style: {
            padding: '8px 0',
          },
        },
      },
    },
    raceMeetingCoupon: {
      configSet: RaceMeetingCoupon,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
